"use client";

import { useEffect } from "react";
import { initPostHog } from "@/lib/posthog/client";

/**
 * Boots PostHog once, for the whole app. Mounted in the root layout next to
 * `PresenceTracker`.
 *
 * Renders nothing and provides no context on purpose — the React tree is left
 * exactly as it was, so mounting this cannot change how any page behaves.
 * Pageviews and route changes are handled inside the SDK via
 * `capture_pageview: "history_change"`, so there is no navigation effect here.
 */
export default function PostHogTracker() {
  useEffect(() => {
    initPostHog();
  }, []);

  return null;
}
